import axios from './api'

export const getProductList = (token = '') => {
  return axios({
    method: 'POST',
    url: '/vademecum/products',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
  })
    .then(res => {
      console.log(res.data.data)
      console.log(res.data.brands)
      return {
        products: res.data.data,
        brands: res.data.brands
      }
    })
}

export const getProductInfo = () => {
  return axios('/site/content/products')
    .then(res => res.data.data)
}